import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { MessageBar, MessageBarType } from "@bps/fluent-ui";
import { XeroFinancialSyncStatus } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";
import { useStores } from "@stores/hooks/useStores.ts";

export const XeroSyncRequestStatusMessageBar: React.FC = observer(() => {
  const { notification, customIntegrationXero } = useStores();
  let message = "";
  if (customIntegrationXero.getFinancialSyncRequestStatus !== undefined) {
    if (
      customIntegrationXero.getFinancialSyncRequestStatus ===
      XeroFinancialSyncStatus.Pending
    ) {
      message = "Loading Xero accounts.";
    } else if (
      customIntegrationXero.getFinancialSyncRequestStatus ===
      XeroFinancialSyncStatus.InternalFailure
    ) {
      message = "Failed to get response for Xero accounts.";
    }
  }

  useEffect(() => {
    if (
      customIntegrationXero.getFinancialSyncRequestStatus ===
      XeroFinancialSyncStatus.Completed
    ) {
      notification.success("Xero accounts loaded.");
    }
  }, [customIntegrationXero.getFinancialSyncRequestStatus, notification]);

  return message !== "" ? (
    <MessageBar messageBarType={MessageBarType.info}>{message}</MessageBar>
  ) : null;
});
